<button
  type="button"
  class="btn btn-primary rounded-2"
  (click)="openMakeAnOffer($event)"
  [disabled]="isDisabled"
  [attr.data-translation-key]="'horse_view_make_an_offer'"
>
  {{ 'horse_view.make_an_offer' | translate }}
</button>
